import LoadView from "Components/Common/loadView";
import SettingsBlock from "Components/Common/Settings/SettingsBlock";
import SwitcherSetting from "Components/Common/Settings/SwitcherSetting";
import TextInputSetting from "Components/Common/Settings/TextInputSetting";
import TextSetting from "Components/Common/Settings/TextSetting";
import Switcher from "Components/Common/switcher";
import TransitionBlocker from "Components/Common/TransitionBlocker";
import { action } from "mobx";
import { observer } from "mobx-react";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import AppStore from "Stores/AppStore";
import DeviceTracesStore from "Stores/deviceTracesStore";
import 'Styles/deviceTraces.scss';

class DeviceTraces extends Component {
    constructor(props) {
        super(props);

        let { pageTitle, params } = AppStore.lastPageInfo;
        let returnParams = '';

        // @ts-ignore
        if (pageTitle === 'users' && params != null && params.page != null)
            // @ts-ignore
            returnParams = `?page=${params.page}`;

        this.state = { returnLink: `${window.SmrLocation}/users${returnParams}` };
    }

    componentDidMount() {
        AppStore.OnMainComponentMount('Логирование');

        let searchParams = new URLSearchParams(window.location.search);
        let deviceId = null;
        if (searchParams.has('deviceId')) {
            let parse = Number.parseInt(searchParams.get('deviceId'));
            if (parse != NaN)
                deviceId = parse;
        }

        DeviceTracesStore.LoadTraceInfo(deviceId);
    }

    componentWillUnmount() {
        DeviceTracesStore.UnloadTraceInfo();
    }

    render() {
        let keyItems = [];

        if (DeviceTracesStore.traceInfo) {
            let knownItems = Object.keys(DeviceTracesStore.traceInfo.knownTraceKeys).map(key => (
                <SwitcherSetting
                    key={key}
                    id={key}
                    title={key}
                    value={DeviceTracesStore.traceInfo.knownTraceKeys[key]}
                    onChanged={action((val) => DeviceTracesStore.traceInfo.knownTraceKeys[key] = val)} />
            ));

            keyItems =
                [
                    <TextInputSetting
                        id='unknownTraces'
                        key='unknownTraces'
                        title="Дополнительно:"
                        helperText="Только латинские буквы, цифры, точка, точка с запятой"
                        value={DeviceTracesStore.traceInfo.unknownTraceKeys}
                        onChanged={action((val) => DeviceTracesStore.traceInfo.unknownTraceKeys = val)}
                        invalid={DeviceTracesStore.unknownKeysInvalid} />
                    ,
                    ...knownItems
                ]
        }

        return (
            <div className="device-traces-container">
                <TransitionBlocker
                    blocked={DeviceTracesStore.GetTracesChanged()}
                    title='У вас есть несохраненные изменения. Если вы покинете страницу, все изменения будут утеряны.' />

                <div className="device-traces-blockandbuttons">
                    <SettingsBlock title='Логи'>
                        <div className='keys-container overflowing-element'>
                            {keyItems}
                        </div>
                    </SettingsBlock>
                    <div className='buttons-container'>
                        <div className="left-buttons">
                            <button className={(DeviceTracesStore.clearTracesAvailable ? '' : ' disabled')}
                                onClick={() => DeviceTracesStore.ClearDeviceTraces()}>
                                Очистить архив
                            </button>
                        </div>
                        <div className="right-buttons">
                            <Link to={this.state.returnLink}>
                                <button>
                                    Отменить
                                </button>
                            </Link>
                            <button className={'blue-button' + (DeviceTracesStore.traceInfo && DeviceTracesStore.unknownKeysInvalid == false ? '' : ' disabled')}
                                onClick={() => DeviceTracesStore.SaveTraceInfo()}>
                                Логировать
                            </button>
                        </div>
                    </div>
                </div>
                {
                    DeviceTracesStore.loaded ? '' : <LoadView modal={true} loading={true} />
                }
            </div>
        )
    }
}

export default observer(DeviceTraces);